import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrameSizeSelectorComponent } from '@nrwl/test-setup';
import { MatDialog } from '@angular/material/dialog';
import { CommonMaterialModule } from '@nrwl/common-material';
import { MatTableDataSource } from '@angular/material/table';
import { state, style, transition, trigger, animate } from '@angular/animations';
import { FormsModule } from '@angular/forms';
import {
  BaseSetupTab,
  IComponentStateHistory,
  IValueChangedEvent,
  REMOVED
} from '@nrwl/test-setup';
import {
  ACCESSRATE_TYPE,
  CVLAN_PRIORITY_TYPE,
  Y1564ConfigFieldMapping,
  DSCP_CONFIG_TYPE,
  ERROR_ON_OSS,
  IPAddressValue,
  KILOBYTE_TYPE,
  PAYLOAD_TYPE,
  SVLAN_PRIORITY_TYPE,
  vlanConfigValue,
  CONFIRM_SELECTION
} from '../../models/models';
import { isNil, cloneDeep, isEmpty } from 'lodash';
import {
  AGENT_MODEL,
  DevicesService,
  FormatService,
  TestLayerValue,
  TestMode
} from '@nrwl/common-lib';
import { Subject, Subscription } from 'rxjs';
import { Y1564SetupService } from '../../y1564-setup.service';
@Component({
  selector: 'nrwl-y1564-streams',
  standalone: true,
  imports: [CommonModule, FrameSizeSelectorComponent, CommonMaterialModule, FormsModule],
  templateUrl: './y1564-streams.component.html',
  styleUrls: ['./y1564-streams.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('isExpanded', style({ height: '*', visibility: 'visible' })),
      transition('isExpanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class Y1564StreamsComponent implements OnInit, OnDestroy {
  @Input() tab: BaseSetupTab;
  @Input() componentId: string;
  @Input() stateHistory: IComponentStateHistory;
  @Input() otherTabStateHistory: IComponentStateHistory;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreAgentBasedConfig?: Function;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  isValidRemoveAction = false;
  disableVerifyDSCP = false;
  isValidCloneAction = false;
  // eslint-disable-next-line
  config: any;
  // eslint-disable-next-line
  parentConfig: any;
  outputs: Array<string>;
  configMapping = Y1564ConfigFieldMapping;
  tabsubscription: Subscription;
  agentSubscription: Subscription;
  readonly unsubscribe: Subject<void> = new Subject();
  currentRowSelected;
  disabledIcon = 'icon mdi mdi-menu-down';
  enabledIcon = 'icon mdi mdi-menu-up';
  isConfigTestEnable = true;
  isPerformanceTestEnable = true;
  //dropdown
  verifyDSCPTypes = CONFIRM_SELECTION;
  dscpConfigTypes = DSCP_CONFIG_TYPE;
  svlanPriorityTypes = SVLAN_PRIORITY_TYPE;
  cvlanPriorityTypes = CVLAN_PRIORITY_TYPE;
  kbSizeTypes = KILOBYTE_TYPE;
  accessRateTypes = ACCESSRATE_TYPE;
  errorOnOssTypes = ERROR_ON_OSS;
  payloadTypes = PAYLOAD_TYPE;
  // eslint-disable-next-line
  maxBwObj: any;
  // eslint-disable-next-line
  allStreamsConfig: Array<any>;
  // eslint-disable-next-line
  defaultStreamsArr: any;
  maxBandWidth = 1000;
  defaultBandWidth = 1000;
  totalMaxLoad: number;
  vlanConfig = vlanConfigValue.UNTAGGED;
  ipAddressType = IPAddressValue.IP_V4;
  ipV6Type = false;
  layer3Test = false;
  testMode = TestMode.LOOPBACK;
  agentType: string;
  hexaDecimalRegex = new RegExp('[A-Fa-f0-9]{2}');
  flowLableRegex = new RegExp('^[1-9A-Fa-f]{1,5}$');
  selectedOriginator: any;
  defaultColumns = [
    'streamName',
    'streamDscp',
    'streamCir',
    'streamEir',
    'streamPolicing',
    'streamLoss',
    'streamFD',
    'streamFrame',
    'streamMaxBw',
    'streamAction'
  ];
  loopbackColumns = [
    'streamName',
    'streamDscp',
    'streamCir',
    'streamEir',
    'streamPolicing',
    'streamLoss',
    'streamFD',
    'streamFrame',
    'streamMaxBw',
    'streamAction'
  ];
  agentToAgentColumns = [
    'streamName',
    'streamDscp',
    'streamCir',
    'streamEir',
    'streamPolicing',
    'streamLoss',
    'streamFrame',
    'streamMaxBw',
    'streamAction'
  ];
  bidirectionalColumns = [
    'streamName',
    'streamDscp',
    'streamDirectional',
    'streamCir',
    'streamEir',
    'streamPolicing',
    'streamLoss',
    'streamFrame',
    'streamMaxBw',
    'streamAction'
  ];
  nonBidirectionalColumns = [
    'streamName',
    'streamDscp',
    'streamCir',
    'streamEir',
    'streamPolicing',
    'streamLoss',
    'streamFD',
    'streamFDV',
    'streamFrame',
    'streamMaxBw',
    'streamAction'
  ];
  dataSource = new MatTableDataSource();
  errorValidationObj = {
    isValidVlan: true,
    isValidDscp: true,
    isValidName: true,
    isValidCir: true,
    isValidEir: true,
    isValidPolicing: true,
    isValidFrameLoss: true,
    isValidFD: true,
    isValidFDV: true,
    isValidCbs: true,
    isValidRepetitions: true,
    isValidOverhead: true,
    isValidFlowlabel: true,
    isValidTTL: true,
    isValidTrafficClass: true,
    isValidDisableStream: true
  };
  validateAllStreams;
  streamRows = [
    {
      isExpanded: false,
      biDirectional: false,
      isMultiSelectEnable: false,
      framesList: null,
      verifyDSCP: false,
      isEnabledPolicing: false,
      isEnabledPolicing2: false,
      isToggledFD: true,
      streamMaxServices: 1,
      streamNumber: 1,
      streamName: 'service 1',
      streamDscp: null,
      stream_svlanPriority: 0,
      stream_cvlanPriority: 0,
      streamCir: 10,
      streamCir2: 10,
      streamEir: 0,
      streamEir2: 0,
      streamPolicing: 0,
      streamPolicing2: 0,
      streamLoss: 0,
      streamFD: 100,
      streamFDV: 100,
      streamSctFrame: 512,
      streamSptFrame: 512,
      streamFrameList: null,
      streamMxBw: 10,
      streamCbs: 0,
      streamKbSize: 'cbs1000',
      streamRepetitions: 1,
      streamAccessRate: 'Mbps1000',
      streamOverheadBytes: 0,
      streamOSS: true,
      streamPayload: 'fill-byte',
      streamFlowLabel: 0,
      streamTrafficClass: '00',
      streamTTL: 255,
      isValidConfig: true,
      sctFrameDisplay: 512,
      sptFrameDisplay: 512,
      strmInUse: true,
      streamFrame: '',
      streamAction: ''
    }
  ];
  isMtsAgent = false;
  isJMEPAgent = false;
  isValidRemove = false;
  constructor(
    private dialog: MatDialog,
    private readonly deviceService: DevicesService,
    public setupService: Y1564SetupService,
    public formatService: FormatService
  ) {
    this.dataSource.data = this.streamRows;
  }

  ngOnInit(): void {
    this.restoreFormValues();
    this.validateStream();
    this.calculateMaxLoad(this.streamRows[0]);
    this.calculateAllStreamsMaxLoad();
    if (this.setupService.tabDataChangeEvents) {
      this.tabsubscription = this.setupService.tabDataChangeEvents.subscribe(event => {
        if (event === 2) {
          this.restoreFormValues();
          this.calculateMaxLoad(this.streamRows[0]);
          this.calculateAllStreamsMaxLoad();
          this.validateStream();
          this.onDataChange();
        }
      });
      this.agentSubscription = this.setupService.agentChangeEvents.subscribe(event => {
        this.streamRows[0].isMultiSelectEnable = false;
      });
    }
  }
  ngOnDestroy(): void {
    this.unsubscribe.complete();
    this.unsubscribe.next();
    if (this.tabsubscription) {
      this.tabsubscription.unsubscribe();
    }
  }

  restoreOtherTabValues(): void {
    this.vlanConfig = this.restoreEndpointsFieldValues(Y1564ConfigFieldMapping.VLAN_CONFIG);
    this.ipAddressType = this.restoreFieldValues(Y1564ConfigFieldMapping.IP_ADDRESS_TYPE);
    this.testMode = this.restoreFieldValues(Y1564ConfigFieldMapping.TEST_MODE);
    this.agentType = this.restoreFieldValues(Y1564ConfigFieldMapping.AGENT_TYPE);
    this.ipV6Type = this.ipAddressType === IPAddressValue.IP_V6;
    this.layer3Test =
      this.restoreFieldValues(Y1564ConfigFieldMapping.LAYER_TO_TEST) === TestLayerValue.L3;
    this.isConfigTestEnable = this.restoreFieldValues(Y1564ConfigFieldMapping.RUN_CONFIG_TEST);
    this.isPerformanceTestEnable = this.restoreFieldValues(Y1564ConfigFieldMapping.RUN_PERF_TEST);
    this.selectedOriginator = this.restoreEndpointsFieldValues(
      Y1564ConfigFieldMapping.SELECTED_ORIGINATOR
    );
  }

  restoreFormValues(): void {
    this.config = this.tab?.config;
    this.restoreOtherTabValues();
    if (this.selectedOriginator && this.config) {
      const capabilityData = this.setupService?.getAgentLookUpData(
        this.config?.lookup,
        this.selectedOriginator
      );
      this.maxBandWidth = capabilityData?.['max_bandwidth']
        ? parseInt(capabilityData?.['max_bandwidth'])
        : this.defaultBandWidth;
    }
    this.defaultStreamsArr = cloneDeep(this.restoreFieldValues(Y1564ConfigFieldMapping.STREAMS));
    this.parentConfig = this.tab?.['parent']['output'];
    this.outputs = this.config?.def?.outputs;
    this.filterColumns();
    const defaultStreamRow = this.streamRows[0];
    this.streamRows = [];
    this.allStreamsConfig = cloneDeep(this.restoreFieldValues(Y1564ConfigFieldMapping.STREAMS));
    for (let i = 0; i < this.allStreamsConfig?.length; i++) {
      this.streamRows.push(cloneDeep(defaultStreamRow));
    }
    for (let i = 0; i < this.allStreamsConfig?.length; i++) {
      this.streamRows[i].streamNumber =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.STREAM_NUMBER];
      this.streamRows[i].streamName = this.allStreamsConfig[i][Y1564ConfigFieldMapping.STREAM_NAME];
      this.streamRows[i].biDirectional = this.restoreFieldValues(
        Y1564ConfigFieldMapping.BI_DIRECTIONAL
      );
      const frameList = this.allStreamsConfig[i][Y1564ConfigFieldMapping.FRAME_LIST];
      this.streamRows[i].framesList = frameList ?? this.getValidFrameSizes();
      this.streamRows[i].framesList[this.parentConfig?.['ip-address-type']]['sctFrameList'] =
        this.updateSctFrames(this.allStreamsConfig[i], 'restore', this.streamRows[i]);
      this.streamRows[i].streamDscp = this.allStreamsConfig[i][Y1564ConfigFieldMapping.TOS] ?? 184;
      this.streamRows[i].stream_svlanPriority =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.SVLAN_PRIORITY];
      this.streamRows[i].stream_cvlanPriority =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.CVLAN_PRIORITY];
      this.streamRows[i].streamCir = this.allStreamsConfig[i][Y1564ConfigFieldMapping.CIR];
      this.streamRows[i].streamCir2 = this.allStreamsConfig[i][Y1564ConfigFieldMapping.CIR2];
      this.streamRows[i].streamEir = this.allStreamsConfig[i][Y1564ConfigFieldMapping.EIR];
      this.streamRows[i].streamEir2 = this.allStreamsConfig[i][Y1564ConfigFieldMapping.EIR2];
      this.streamRows[i].streamMaxServices = this.restoreFieldValues(
        Y1564ConfigFieldMapping.MAX_SERVICES
      );
      this.streamRows[i].verifyDSCP =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.VERIFY_DSCP] ?? false;
      this.streamRows[i].isEnabledPolicing =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.POLICING];
      this.streamRows[i].isEnabledPolicing2 =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.POLICING2];
      this.streamRows[i].isToggledFD = this.isNotNillValue(
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.FD]
      );
      this.streamRows[i].streamPolicing =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.MAX_IR] ?? 0;
      this.streamRows[i].streamPolicing2 =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.MAX_IR2] ?? 0;
      this.streamRows[i].streamLoss = this.allStreamsConfig[i][Y1564ConfigFieldMapping.LOSS];
      this.streamRows[i].streamFD = this.allStreamsConfig[i][Y1564ConfigFieldMapping.FD] || 100;
      this.streamRows[i].streamFDV = this.allStreamsConfig[i][Y1564ConfigFieldMapping.FDV];
      this.streamRows[i].streamSctFrame =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.SCT_FRAME_SIZE];
      this.streamRows[i].streamSptFrame =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.SPT_FRAME_SIZE];
      if (this.agentType === AGENT_MODEL.QT600) {
        this.streamRows[i].streamCbs = this.allStreamsConfig[i][Y1564ConfigFieldMapping.CBS] || 0;
        this.streamRows[i].streamKbSize =
          this.allStreamsConfig[i][Y1564ConfigFieldMapping.KB_SIZE] || 'cbs1000';
        this.streamRows[i].streamRepetitions =
          this.allStreamsConfig[i][Y1564ConfigFieldMapping.CBS_REPETITIONS] || 1;
        this.streamRows[i].streamAccessRate =
          this.allStreamsConfig[i][Y1564ConfigFieldMapping.CBS_LINE_RATE] || 'Mbps1000';
      }
      this.streamRows[i].streamOverheadBytes =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.OVER_HEAD_BYTES];
      this.streamRows[i].streamOSS = this.allStreamsConfig[i][Y1564ConfigFieldMapping.ERROR_ON_OSS];
      this.streamRows[i].streamPayload =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.PAYLOAD_TYPE];
      this.streamRows[i].streamFlowLabel =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.FLOW_LABEL];
      this.streamRows[i].streamTrafficClass =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.TRAFFIC_CLASS] || '00';
      this.allStreamsConfig[i][Y1564ConfigFieldMapping.TTL] =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.TTL] || 255;
      this.allStreamsConfig[i][Y1564ConfigFieldMapping.HOP_LIMIT] =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.HOP_LIMIT] || 64;
      this.streamRows[i].streamTTL = !this.ipV6Type
        ? this.allStreamsConfig[i][Y1564ConfigFieldMapping.TTL]
        : this.allStreamsConfig[i][Y1564ConfigFieldMapping.HOP_LIMIT];
      this.sctFrameLabelDisplay(this.streamRows[i]);
      this.sptFrameLabelDisplay(this.streamRows[i]);
      this.calculateMaxLoad(this.streamRows[i]);
      this.streamRows[i].strmInUse =
        this.allStreamsConfig[i][Y1564ConfigFieldMapping.STREAM_IN_USE] ?? true;
    }
    this.calculateAllStreamsMaxLoad();
    this.dataSource.data = this.streamRows;
    this.filterColumns();
    this.isMtsAgent = this.deviceService.isMtsAgentModel(this.agentType);
    this.isJMEPAgent = this.agentType.indexOf('JMEP') !== -1;
  }

  filterColumns(): void {
    if (this.testMode.indexOf('bidirectional') !== -1) {
      this.defaultColumns = this.bidirectionalColumns;
    } else if (this.testMode === TestMode.UNIDIRECIONAL) {
      this.defaultColumns = this.agentToAgentColumns;
    } else if (
      this.selectedOriginator?.deviceData?.model?.model?.indexOf('vTA') === -1 &&
      this.selectedOriginator?.deviceData?.model?.model?.indexOf('vSPA') === -1
    ) {
      this.defaultColumns = this.nonBidirectionalColumns;
    } else {
      this.defaultColumns = this.loopbackColumns;
    }
  }
  showFormField(field: string): boolean {
    return this.defaultStreamsArr?.map(item => item[field] !== undefined)[0];
  }

  //eslint-disable-next-line
  isNotNillValue(value: any): boolean {
    return !isNil(value);
  }

  showFDToggle(): boolean {
    return this.agentType !== AGENT_MODEL.QT600 && !this.agentType.includes('JMEP');
  }
  //eslint-disable-next-line
  restoreFieldValues(field: string): any {
    const data = this.stateHistory(this.componentId, field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  //eslint-disable-next-line
  restoreEndpointsFieldValues(field: string): any {
    const data = this.otherTabStateHistory('y1564.endpoints.html', field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  expandCollapse(row: any): void {
    if (this.currentRowSelected && this.currentRowSelected != row)
      this.currentRowSelected.isExpanded = false;
    this.currentRowSelected = row;

    if (row.isExpanded) {
      row.isExpanded = false;
    } else {
      row.isExpanded = true;
    }
  }

  getValidFrameSizes(): Array<number> {
    const singleVlanSize = this.restoreFieldValues(Y1564ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE);
    const doubleVlanSize = this.restoreFieldValues(Y1564ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE);
    if (this.vlanConfig === vlanConfigValue.SINGLE_VLAN && singleVlanSize) {
      return singleVlanSize;
    } else if (this.vlanConfig === vlanConfigValue.Q_IN_Q && doubleVlanSize) {
      return doubleVlanSize;
    }
    const validFramesList = cloneDeep(
      this.restoreFieldValues(Y1564ConfigFieldMapping.VALID_FRAME_SIZE)
    );
    return validFramesList;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  removeStream(rowData: any): void {
    if (this.streamRows.length > 1) {
      this.streamRows = this.streamRows.filter(
        item => item['streamNumber'] !== rowData.streamNumber
      );
      this.dataSource.data = this.streamRows;
      this.allStreamsConfig = this.allStreamsConfig.filter(
        item => item[Y1564ConfigFieldMapping.STREAM_NUMBER] !== rowData.streamNumber
      );
    }
    this.validateStream();
    this.onDataChange();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  calculateMaxLoad(selectedRow: any): void {
    let maxIr1 = 0;
    let maxIr2 = 0;
    let cir1 = 0;
    let cir2 = 0;
    let accessRate1 = 0;
    let accessRate2 = 0;
    // if enabled, get max IR for 2-way and A to B
    const rtnVals = this.calcServiceConfigIR(
      selectedRow,
      selectedRow.streamCir,
      selectedRow.streamEir
    );
    if (typeof rtnVals === 'object' && rtnVals.length > 2) {
      cir1 = rtnVals[0];
      accessRate1 = rtnVals[1];
      maxIr1 = rtnVals[2];
    }

    // // if enabled, get max IR for B to A
    if (this.testMode.indexOf('bidirectional') !== -1) {
      const rtnVals = this.calcServiceConfigIR(
        selectedRow,
        selectedRow.streamCir2,
        selectedRow.streamEir2
      );
      if (typeof rtnVals === 'object' && rtnVals.length > 2) {
        cir2 = rtnVals[0];
        accessRate2 = rtnVals[1];
        maxIr2 = rtnVals[2];
      }
    }

    // Take the largest one-way IR or use the 2-way IR
    const streamMaxCIR = Math.max(cir1, cir2);
    const streamMaxAccessRate = Math.max(accessRate1, accessRate2);
    const streamMaxIR = Math.max(maxIr1, maxIr2);

    // Convert max ULR to max IR (meaning include ethernet overhead) based on smallest frame size
    let sctLoad = 0;
    let sptLoad = 0;
    if (streamMaxIR > 0) {
      sctLoad = this.getStreamConfULR(selectedRow, streamMaxIR); // determine ULR based on smallest frame size
      sptLoad = this.getStreamPerfULR(selectedRow, streamMaxCIR); // determine ULR based on frame size                            // already in ULR
      sctLoad = Math.max(sctLoad, streamMaxAccessRate); // access rate is always in ULR
      sctLoad = Math.round(sctLoad * 100) / 100;
      sptLoad = Math.round(sptLoad * 100) / 100;
    }
    let streamMax = 0;
    if (
      this.parentConfig?.['run-config-test'] &&
      this.parentConfig?.['run-perf-test'] &&
      sctLoad &&
      sptLoad
    ) {
      streamMax = Math.max(sctLoad, sptLoad);
    } else if (this.parentConfig?.['run-config-test'] && sctLoad) {
      streamMax = sctLoad;
    } else if (this.parentConfig?.['run-perf-test']) {
      streamMax = sptLoad;
    }

    const maxBW = Math.round(streamMax * 100) / 100;
    if (!selectedRow.strmInUse) {
      selectedRow.streamMxBw = 0;
    } else {
      selectedRow.streamMxBw = this.formatService.formatMegaBites(maxBW, 2);
    }
    this.calculateTotalMaxBandWidth();
  }

  calculateAllStreamsMaxLoad(): void {
    this.totalMaxLoad = 0;
    this.streamRows.forEach(item => {
      let maxIr1 = 0;
      let maxIr2 = 0;
      let cir1 = 0;
      let cir2 = 0;
      let accessRate1 = 0;
      let accessRate2 = 0;
      // if enabled, get max IR for 2-way and A to B
      const rtnVals = this.calcServiceConfigIR(item, item.streamCir, item.streamEir);
      if (typeof rtnVals === 'object' && rtnVals.length > 2) {
        cir1 = rtnVals[0];
        accessRate1 = rtnVals[1];
        maxIr1 = rtnVals[2];
      }

      // // if enabled, get max IR for B to A
      if (this.testMode.indexOf('bidirectional') !== -1) {
        const rtnVals = this.calcServiceConfigIR(item, item.streamCir2, item.streamEir2);
        if (typeof rtnVals === 'object' && rtnVals.length > 2) {
          cir2 = rtnVals[0];
          accessRate2 = rtnVals[1];
          maxIr2 = rtnVals[2];
        }
      }

      // Take the largest one-way IR or use the 2-way IR
      const streamMaxCIR = Math.max(cir1, cir2);
      const streamMaxAccessRate = Math.max(accessRate1, accessRate2);
      const streamMaxIR = Math.max(maxIr1, maxIr2);

      // Convert max ULR to max IR (meaning include ethernet overhead) based on smallest frame size
      let sctLoad = 0;
      let sptLoad = 0;
      if (streamMaxIR > 0) {
        sctLoad = this.getStreamConfULR(item, streamMaxIR); // determine ULR based on smallest frame size
        sptLoad = this.getStreamPerfULR(item, streamMaxCIR); // determine ULR based on frame size                            // already in ULR
        sctLoad = Math.max(sctLoad, streamMaxAccessRate); // access rate is always in ULR
        sctLoad = Math.round(sctLoad * 100) / 100;
        sptLoad = Math.round(sptLoad * 100) / 100;
      }
      let streamMax = 0;
      if (
        this.parentConfig?.['run-config-test'] &&
        this.parentConfig?.['run-perf-test'] &&
        sctLoad &&
        sptLoad
      ) {
        streamMax = Math.max(sctLoad, sptLoad);
      } else if (this.parentConfig?.['run-config-test'] && sctLoad) {
        streamMax = sctLoad;
      } else if (this.parentConfig?.['run-perf-test']) {
        streamMax = sptLoad;
      }
      const maxBW = Math.round(streamMax * 100) / 100;
      if (item.strmInUse) {
        this.totalMaxLoad = this.totalMaxLoad + maxBW;
      } else {
        item.streamMxBw = 0;
      }
    });
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  calcServiceConfigIR(selectedRow: any, cir: number, eir: number): any {
    let twentyFivePercent = 0;
    let accessRate = 0;
    // get access rate
    if (selectedRow.streamCbs !== 0) {
      if (selectedRow.streamAccessRate === 'Mbps10') {
        accessRate = 10;
      } else if (selectedRow.streamAccessRate === 'Mbps100') {
        accessRate = 100;
      } else if (selectedRow.streamAccessRate === 'Mbps1000') {
        accessRate = 1000;
      } else if (selectedRow.streamAccessRate === 'Mbps10000') {
        accessRate = 10000;
      }
    }
    // add 25% of cir or eir if policing is enabled
    if (selectedRow.isEnabledPolicing) {
      // if EIR < 20% CIR, use 25% CIR otherwise use 25% EIR
      if (eir < 0.2 * cir) {
        twentyFivePercent = 0.25 * cir;
      } else {
        twentyFivePercent = 0.25 * eir;
      }
    }
    const streamIR = cir + eir + twentyFivePercent;
    return [cir, accessRate, streamIR];
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  getStreamConfULR(selectedRow: any, IR: number): any {
    let frameStr = selectedRow?.streamSctFrame;
    if (frameStr?.indexOf('EMIX:') !== -1) {
      frameStr = frameStr?.replace('EMIX:', '');
    }
    if (frameStr?.indexOf('custom:') !== -1) {
      frameStr = frameStr?.replace('custom:', '');
    }
    if (frameStr?.indexOf(':') !== -1) {
      frameStr = frameStr?.replaceAll(':', ',');
    }
    const emixFrames = frameStr?.toString().split(',');
    if (emixFrames?.length > 1) {
      let sum = 0;
      const len = emixFrames?.length;
      for (let i = 0; i < len; ++i) {
        if (emixFrames[i]) {
          sum += parseInt(emixFrames[i], 10);
        }
      }
      return this.convertIRtoULR(IR, Math.round(sum / len));
    } else {
      return this.convertIRtoULR(IR, parseInt(frameStr));
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  getStreamPerfULR(selectedRow: any, IR: number): any {
    let frameStr = selectedRow?.streamSptFrame;
    if (frameStr?.indexOf('EMIX:') !== -1 && frameStr?.indexOf('custom:') === -1) {
      frameStr = frameStr?.replace('EMIX:', '');
      const emixFrames = frameStr?.replaceAll(':', ',').split(',');
      let sum = 0;
      const len = emixFrames?.length;
      for (let i = 0; i < len; ++i) {
        if (emixFrames[i]) {
          sum += parseInt(emixFrames[i], 10);
        }
      }
      return this.convertIRtoULR(IR, Math.round(sum / len));
    } else {
      if (frameStr?.indexOf('custom:') !== -1) {
        frameStr = frameStr?.replace('custom:', '');
      }
      return this.convertIRtoULR(IR, parseInt(frameStr));
    }
  }
  convertIRtoULR(IR: number, frameSize: number): number {
    let localVlanCount = 0;
    if (
      this.vlanConfig === vlanConfigValue.Q_IN_Q &&
      this.parentConfig?.['vlan-id'] !== '' &&
      this.parentConfig?.['inner-vlan-id'] !== ''
    ) {
      localVlanCount = 2;
    } else if (this.vlanConfig === vlanConfigValue.SINGLE_VLAN && this.parentConfig?.sVlan !== '') {
      localVlanCount = 1;
    }
    let remoteVlanCount = 0;
    if (this.parentConfig?.['remote-tag-count']) {
      remoteVlanCount = this.parentConfig?.['remote-tag-count'];
    }
    let ulr = IR * ((frameSize + 20 + localVlanCount * 4) / (frameSize + 20 + remoteVlanCount * 4));

    if (this.parentConfig?.['unit-convention'] === 'l2-mbps') {
      ulr = (ulr * (frameSize + 20)) / frameSize;
    }
    ulr = Math.round(ulr * 100) / 100; //Round to two decimal places
    return ulr;
  }
  calculateTotalMaxBandWidth(): string {
    this.maxBwObj = this.streamRows.map(item => item?.['streamMxBw']);
    let totalMaxBw = 0;
    this.maxBwObj.forEach(item => {
      if (item?.toString().indexOf('Gbps') !== -1) {
        item = parseFloat(item) * 1000;
      } else if (item?.toString().indexOf('Tbps') !== -1) {
        item = parseFloat(item) * 1000 * 1000;
      } else if (item?.toString().indexOf('Pbps') !== -1) {
        item = parseFloat(item) * 1000 * 1000 * 1000;
      } else if (item?.toString().indexOf('Ebps') !== -1) {
        item = parseFloat(item) * 1000 * 1000 * 1000 * 1000;
      } else if (item?.toString().indexOf('Zbps') !== -1) {
        item = parseFloat(item) * 1000 * 1000 * 1000 * 1000 * 1000;
      } else if (item?.toString().indexOf('Ybps') !== -1) {
        item = parseFloat(item) * 1000 * 1000 * 1000 * 1000 * 1000 * 1000;
      }
      totalMaxBw = totalMaxBw + parseFloat(item);
    });
    return this.formatService.formatMegaBites(totalMaxBw, 2);
  }
  // eslint-disable-next-line
  vlidateMaxLoad(element?: any): boolean {
    if (element) {
      this.calculateMaxLoad(element);
      this.calculateAllStreamsMaxLoad();
    }
    if (this.maxBandWidth < this.totalMaxLoad) {
      return true;
    } else {
      return false;
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  cloneStream(rowData: any): void {
    if (this.streamRows.length < 10) {
      this.createDataSource(rowData);
      this.calculateMaxLoad(this.streamRows[this.streamRows.length - 1]);
      this.calculateAllStreamsMaxLoad();
    }
    this.validateStream();
    this.onDataChange();
  }

  calculateDSCPValue(): void {
    if (this.streamRows?.length > 1) {
      this.streamRows.forEach(stream => (stream.verifyDSCP = true));
    }
    if (this.allStreamsConfig?.length > 1) {
      this.allStreamsConfig.forEach(stream => (stream[Y1564ConfigFieldMapping.VERIFY_DSCP] = true));
    }
  }

  validateStream(): void {
    if (this.streamRows.length < this.streamRows[0].streamMaxServices) {
      this.isValidCloneAction = false;
      if (this.streamRows.length > 1) {
        this.isValidRemoveAction = false;
        this.disableVerifyDSCP = true;
      } else {
        this.isValidRemoveAction = true;
        this.disableVerifyDSCP = false;
      }
    } else {
      this.disableVerifyDSCP = true;
      this.isValidRemoveAction = false;
      this.isValidCloneAction = true;
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  checkValidation(field: string, value: any, element?: any): any {
    const errMsg = { isValid: false, message: '' };
    if (field === 'dscp' && this.validateDscp(value)) {
      errMsg.isValid = true;
      errMsg.message = 'This DiffServ is already used by another stream.';
      this.errorValidationObj.isValidDscp = false;
    } else if (field === 'dscp') {
      this.errorValidationObj.isValidDscp = true;
    }
    if (
      (field === 'svlan' || field === 'cvlan') &&
      !this.layer3Test &&
      this.agentType !== AGENT_MODEL.MAP2100 &&
      this.validateVLANPriorities(value, element)
    ) {
      errMsg.isValid = true;
      if (this.vlanConfig === vlanConfigValue.Q_IN_Q) {
        errMsg.message = 'This VLAN/CVLAN Priority combo is already used by another stream.';
      } else {
        errMsg.message = 'This SVLAN Priority is used by another stream.';
      }
      this.errorValidationObj.isValidVlan = false;
    } else if (field === 'svlan' || field === 'cvlan') {
      this.errorValidationObj.isValidVlan = true;
    }

    if (field === 'name' && this.validateName(value)) {
      errMsg.isValid = true;
      errMsg.message =
        'The value ' + value + ' has already been used. Please choose a unique value.';
      this.errorValidationObj.isValidName = false;
    } else if (field === 'name' && isEmpty(value)) {
      errMsg.isValid = true;
      errMsg.message = 'Name is required';
      this.errorValidationObj.isValidName = false;
    } else if (field === 'name') {
      this.errorValidationObj.isValidName = true;
    }
    if (
      field === 'cir' &&
      (this.agentType === AGENT_MODEL.VTA || this.agentType === AGENT_MODEL.VSPA_SAT) &&
      (!Number.isInteger(value) || value < 0 || value > this.maxBandWidth)
    ) {
      errMsg.isValid = true;
      errMsg.message = 'Enter valid cir integer value from 0 - ' + this.maxBandWidth;
      this.errorValidationObj.isValidCir = false;
    } else if (
      field === 'cir' &&
      this.agentType !== AGENT_MODEL.VTA &&
      this.agentType !== AGENT_MODEL.VSPA_SAT &&
      (value === null || value < 0.01 || value > this.maxBandWidth)
    ) {
      errMsg.isValid = true;
      errMsg.message = 'Valid cir is 0.01-' + this.maxBandWidth;
      this.errorValidationObj.isValidCir = false;
    } else if (field === 'cir') {
      this.errorValidationObj.isValidCir = true;
    }
    if (field === 'eir' && value && (value < 0.01 || value > this.maxBandWidth)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid eir is 0.01-' + this.maxBandWidth;
      this.errorValidationObj.isValidEir = false;
    } else if (field === 'eir') {
      this.errorValidationObj.isValidEir = true;
    }
    if (
      field === 'policing' &&
      (value === null || value < 0 || value > this.excessAllowedRate(element))
    ) {
      errMsg.isValid = true;
      errMsg.message = 'Valid policing is 0-' + this.excessAllowedRate(element);
      this.errorValidationObj.isValidPolicing = false;
    } else if (field === 'policing') {
      this.errorValidationObj.isValidPolicing = true;
    }
    if (field === 'loss' && (value === null || value < 0 || value > 100)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid frameloss is 0-100';
      this.errorValidationObj.isValidFrameLoss = false;
    } else if (field === 'loss') {
      this.errorValidationObj.isValidFrameLoss = true;
    }
    const fdMinValue =
      this.agentType === AGENT_MODEL.VTA || this.agentType === AGENT_MODEL.VSPA_SAT ? 0.1 : 0.001;
    if (field === 'fd' && (value === null || value < fdMinValue || value > 1000)) {
      errMsg.isValid = true;
      errMsg.message = `Valid fd is ${fdMinValue}-1000`;
      this.errorValidationObj.isValidFD = false;
    } else if (field === 'fd') {
      this.errorValidationObj.isValidFD = true;
    }
    if (field === 'fdv' && (value === null || value < 0.001 || value > 1000)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid fdv is 0.001-1000';
      this.errorValidationObj.isValidFDV = false;
    } else if (field === 'fdv') {
      this.errorValidationObj.isValidFDV = true;
    }
    if (field === 'cbs' && value && (value < 1 || value > 1024)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid cbs is 1-1024';
      this.errorValidationObj.isValidCbs = false;
    } else if (field === 'cbs') {
      this.errorValidationObj.isValidCbs = true;
    }
    if (field === 'repetitions' && (value === null || value < 1 || value > 1000)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid repetitions is 1-1000';
      this.errorValidationObj.isValidRepetitions = false;
    } else if (field === 'repetitions') {
      this.errorValidationObj.isValidRepetitions = true;
    }
    if (field === 'overhead' && (value === null || value < 0 || value > 255)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid overhead is 0-255';
      this.errorValidationObj.isValidOverhead = false;
    } else if (field === 'overhead') {
      this.errorValidationObj.isValidOverhead = true;
    }
    if (field === 'flowlabel' && !this.flowLableRegex.test(value)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid flow label is 1-FFFFF';
      this.errorValidationObj.isValidFlowlabel = false;
    } else if (field === 'flowlabel') {
      this.errorValidationObj.isValidFlowlabel = true;
    }
    if (field === 'trafficclass' && !this.hexaDecimalRegex.test(value)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid traffic class is 00-FF';
      this.errorValidationObj.isValidTrafficClass = false;
    } else if (
      field === 'trafficclass' &&
      this.layer3Test &&
      this.ipV6Type &&
      this.validateTrafficClassDuplicates(value)
    ) {
      errMsg.isValid = true;
      errMsg.message = 'This traffic class is used by another stream.';
      this.errorValidationObj.isValidTrafficClass = false;
    } else if (field === 'trafficclass') {
      this.errorValidationObj.isValidTrafficClass = true;
    }
    if (field === 'ttl' && (value === null || value < 1 || value > 255)) {
      errMsg.isValid = true;
      errMsg.message = 'Valid ttl is 1-255';
      this.errorValidationObj.isValidTTL = false;
    } else if (field === 'ttl') {
      this.errorValidationObj.isValidTTL = true;
    }
    if (field === 'actionDisable') {
      const enableStreams = this.allStreamsConfig.filter(
        item => item[Y1564ConfigFieldMapping.STREAM_IN_USE]
      );
      if (enableStreams?.length <= 1) {
        this.errorValidationObj.isValidDisableStream = false;
      } else {
        this.errorValidationObj.isValidDisableStream = true;
      }
    }
    if (element) {
      if (
        this.errorValidationObj.isValidVlan &&
        this.errorValidationObj.isValidDscp &&
        this.errorValidationObj.isValidName &&
        this.errorValidationObj.isValidCir &&
        this.errorValidationObj.isValidEir &&
        this.errorValidationObj.isValidPolicing &&
        this.errorValidationObj.isValidFD &&
        this.errorValidationObj.isValidFDV &&
        this.errorValidationObj.isValidFrameLoss &&
        this.errorValidationObj.isValidRepetitions &&
        this.errorValidationObj.isValidOverhead &&
        this.errorValidationObj.isValidFlowlabel &&
        this.errorValidationObj.isValidTTL &&
        this.errorValidationObj.isValidTrafficClass
      ) {
        element.isValidConfig = true;
      } else {
        element.isValidConfig = false;
      }
    }
    this.onDataChange();
    return errMsg;
    // }
  }
  validateName(value: string): boolean {
    const streamNames = this.streamRows
      .map(item => item['streamName'])
      .filter(item => item === value);
    if (streamNames?.length > 1) {
      return true;
    } else {
      return false;
    }
  }
  validateDscp(value: string): boolean {
    if (
      !this.ipV6Type &&
      this.agentType !== AGENT_MODEL.VSPA_SAT &&
      (this.parentConfig?.layer === TestLayerValue.L3 ||
        this.parentConfig?.layer === TestLayerValue.L4)
    ) {
      const streamDscp = this.streamRows.filter(item => item['streamDscp'] === value);
      if (streamDscp?.length > 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  // eslint-disable-next-line
  validateTrafficClassDuplicates(value: any): boolean {
    const streamTrafficClass = this.streamRows
      .map(item => item['streamTrafficClass'])
      .filter(item => item === value);
    if (streamTrafficClass?.length > 1) {
      return true;
    } else {
      return false;
    }
  }
  validateVLANPriorities(value: string, element: string): boolean {
    if (this.vlanConfig === vlanConfigValue.Q_IN_Q) {
      if (element) {
        const streamVlans = this.streamRows
          .map(item => item['stream_svlanPriority'] + ':' + item['stream_cvlanPriority'])
          .filter(
            item => item === element['stream_svlanPriority'] + ':' + element['stream_cvlanPriority']
          );
        if (streamVlans?.length > 1) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      const streamVlans = this.streamRows
        .map(item => item['stream_svlanPriority'])
        .filter(item => item === parseInt(value));
      if (streamVlans?.length > 1) {
        return true;
      } else {
        return false;
      }
    }
  }
  getMaxStreamTooltip(): string {
    let tooltipMsg = '';
    if (this.isValidCloneAction) {
      tooltipMsg =
        'Selected device will supports ' + this.streamRows[0].streamMaxServices + ' streams only.';
    }
    return tooltipMsg;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  excessAllowedRate(element: any): any {
    let maxBandwidth;
    const percentEIRIsOverCIR = (element.streamEir / element.streamCir) * 100;
    if (percentEIRIsOverCIR >= 20) {
      maxBandwidth = (element.streamEir * 0.25).toFixed(2);
    } else {
      maxBandwidth = (element.streamCir * 0.25).toFixed(2);
    }
    return maxBandwidth;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  sctFrameLabelDisplay(element: any): any {
    let selectedFrames = [];
    if (element['frame-list']) {
      selectedFrames = element['frame-list'][this.ipAddressType]['sctFrameList']
        .filter(item => item['enable'])
        .map(item => item['label']);
    } else {
      selectedFrames = element.framesList[this.ipAddressType]['sctFrameList']
        .filter(item => item['enable'])
        .map(item => item['label']);
    }
    if (selectedFrames.length > 1) {
      element.sctFrameDisplay = 'MUL';
      if (element.streamSctFrame !== element.streamSptFrame) {
        element.isMultiSelectEnable = true;
      } else {
        element.isMultiSelectEnable = false;
      }
    } else if (selectedFrames.length === 1 && selectedFrames.indexOf('EMIX') !== -1) {
      element.sctFrameDisplay = 'EMIX';
    } else if (selectedFrames.length === 1 && selectedFrames.indexOf('custom') !== -1) {
      element.sctFrameDisplay = selectedFrames;
    } else {
      element.sctFrameDisplay = element.streamSctFrame;
    }
    return element.sctFrameDisplay;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  sptFrameLabelDisplay(element: any): any {
    if (element.streamSptFrame?.indexOf('EMIX') !== -1) {
      element.sptFrameDisplay = 'EMIX';
    } else if (element.streamSptFrame?.indexOf('custom') !== -1) {
      element.sptFrameDisplay = element.streamSptFrame;
    } else {
      element.sptFrameDisplay = element.streamSptFrame;
    }
    return element.sptFrameDisplay;
  }
  addStream(): void {
    if (this.streamRows.length < this.streamRows[0].streamMaxServices) {
      this.createDataSource();
    }
    this.calculateMaxLoad(this.streamRows[this.streamRows.length - 1]);
    this.calculateAllStreamsMaxLoad();
    this.validateStream();
    this.onDataChange();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  createDataSource(rowData?: any): any {
    const validFramesList = cloneDeep(
      this.restoreFieldValues(Y1564ConfigFieldMapping.VALID_FRAME_SIZE)
    );
    const stream = {
      isExpanded: rowData ? rowData.isExpanded : false,
      biDirectional: rowData ? rowData.biDirectional : false,
      isMultiSelectEnable: false,
      framesList: rowData ? rowData.framesList : validFramesList,
      verifyDSCP: rowData ? rowData.verifyDSCP : false,
      isEnabledPolicing: rowData ? rowData.isEnabledPolicing : false,
      isEnabledPolicing2: rowData ? rowData.isEnabledPolicing2 : false,
      isToggledFD: rowData ? rowData.isToggledFD : true,
      streamMaxServices: rowData
        ? rowData.streamMaxServices
        : this.config['valuesDefault']['maxServices'],
      streamNumber: this.getStreamName(),
      streamName: 'service ' + this.getStreamName(),
      streamDscp: rowData ? rowData.streamDscp : 184,
      stream_svlanPriority: this.getPriorities(),
      stream_cvlanPriority: this.getPriorities(),
      streamCir: rowData ? rowData.streamCir : 10,
      streamCir2: rowData ? rowData.streamCir2 : 10,
      streamEir: rowData ? rowData.streamEir : 0,
      streamEir2: rowData ? rowData.streamEir2 : 0,
      streamPolicing: rowData ? rowData.streamPolicing : 0,
      streamPolicing2: rowData ? rowData.streamPolicing2 : 0,
      streamLoss: rowData ? rowData.streamLoss : 0,
      streamFD: rowData ? rowData.streamFD : 100,
      streamFDV: rowData ? rowData.streamFDV : 100,
      streamSctFrame: rowData ? rowData.streamSctFrame : [512],
      streamSptFrame: rowData ? rowData.streamSptFrame : [512],
      streamMxBw: rowData ? rowData.streamMaxBw : '10.002',
      streamCbs: rowData ? rowData.streamCbs : 0,
      streamKbSize: rowData ? rowData.streamKbSize : 'cbs1000',
      streamRepetitions: rowData ? rowData.streamRepetitions : 1,
      streamAccessRate: rowData ? rowData.streamAccessRate : 'Mbps1000',
      streamOverheadBytes: rowData ? rowData.streamOverheadBytes : 0,
      streamOSS: rowData ? rowData.streamOSS : true,
      streamPayload: rowData ? rowData.streamPayload : 'fill-byte',
      streamFlowLabel: rowData ? rowData.streamFlowLabel : 1,
      streamTrafficClass: rowData ? rowData.streamTrafficClass : '00',
      streamTTL: rowData ? rowData.streamTTL : this.streamRows?.[0]?.['streamTTL'] || 255,
      isValidConfig: true,
      sctFrameDisplay: 512,
      sptFrameDisplay: 512,
      streamFrameList: rowData ? rowData.streamFrameList : null,
      strmInUse: rowData ? rowData.strmInUse : true,
      streamFrame: rowData ? rowData.streamFrame : '',
      streamAction: rowData ? rowData.streamAction : ''
    };
    const streamNumber = this.getStreamName();
    if (streamNumber > 10) {
      stream.streamTrafficClass = rowData ? rowData.streamTrafficClass : streamNumber - 1;
    } else {
      stream.streamTrafficClass = rowData ? rowData.streamTrafficClass : '0' + (streamNumber - 1);
    }
    this.defaultStreamsArr[this.defaultStreamsArr.length - 1]['stream-in-use'] = true;
    this.defaultStreamsArr[this.defaultStreamsArr.length - 1]['stream-number'] =
      this.getStreamName();
    this.defaultStreamsArr[this.defaultStreamsArr.length - 1]['name'] =
      'service ' + this.getStreamName();
    this.defaultStreamsArr[this.defaultStreamsArr.length - 1]['vlan-priority'] =
      this.getPriorities();
    this.defaultStreamsArr[this.defaultStreamsArr.length - 1]['inner-vlan-priority'] =
      this.getPriorities();
    if (this.defaultStreamsArr[this.defaultStreamsArr.length - 1]?.['traffic-class']) {
      this.defaultStreamsArr[this.defaultStreamsArr.length - 1]['traffic-class'] =
        stream.streamTrafficClass;
    }

    this.allStreamsConfig.push(
      cloneDeep(this.defaultStreamsArr[this.defaultStreamsArr.length - 1])
    );
    this.streamRows.push(stream);
    this.calculateDSCPValue();
    this.dataSource.data = this.streamRows;
  }
  getStreamName(): number {
    return this.streamRows?.[this.streamRows.length - 1]?.streamNumber + 1;
  }
  getPriorities(): number {
    return this.streamRows[this.streamRows.length - 1].stream_svlanPriority + 1 < 8
      ? this.streamRows[this.streamRows.length - 1].stream_svlanPriority + 1
      : 0;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  updateSctFrames(rowData: any, action: any, streamRow?: any): any {
    let sctframes;
    let sctFrameList;
    if (action === 'popup') {
      sctframes = rowData.streamSctFrame;
      sctFrameList = rowData.framesList[this.parentConfig?.['ip-address-type']]['sctFrameList'];
    } else {
      sctframes = rowData.streamSctFrame || rowData[Y1564ConfigFieldMapping.SCT_FRAME_SIZE];
      sctFrameList = streamRow.framesList[this.parentConfig?.['ip-address-type']]['sctFrameList'];
    }
    let index = 0;
    let isEmix = false;
    if (sctframes?.indexOf('EMIX') !== -1) {
      isEmix = true;
      sctframes = sctframes?.split('EMIX');
    }
    sctFrameList?.forEach(item => {
      index = index + 1;
      if (!isEmix) {
        if (sctframes?.toString()?.split(',')?.includes(item.label?.toString())) {
          sctFrameList[index - 1]['enable'] = true;
        } else if (item.label?.toString() === 'custom' && sctframes?.indexOf('custom') !== -1) {
          sctFrameList[index - 1]['enable'] = true;
          sctFrameList[index - 1]['value'] =
            rowData.streamSctFrame?.split('custom:')[1]?.replace(',', '') ||
            rowData[Y1564ConfigFieldMapping.SCT_FRAME_SIZE]?.split('custom:')[1]?.replace(',', '');
        } else {
          sctFrameList[index - 1]['enable'] = false;
        }
      } else if (isEmix && sctframes && sctframes[0] && sctFrameList[index - 1].label !== 'EMIX') {
        if (sctframes[0]?.split(',')?.includes(item['label']?.toString())) {
          sctFrameList[index - 1]['enable'] = true;
        } else if (item['label'] === 'custom' && sctframes[0]?.indexOf('custom') !== -1) {
          const customFrameValue =
            rowData.streamSctFrame?.split('custom:') ||
            rowData[Y1564ConfigFieldMapping.SCT_FRAME_SIZE]?.split('custom:');
          const FrameValue = customFrameValue[1]?.split('EMIX:');
          sctFrameList[index - 1]['enable'] = true;
          sctFrameList[index - 1]['value'] = FrameValue[0]?.replace(',', '');
        } else {
          sctFrameList[index - 1]['enable'] = false;
        }
      } else if (isEmix && sctframes?.length > 1 && sctFrameList[index - 1].label === 'EMIX') {
        sctFrameList[index - 1]['enable'] = true;
        sctFrameList[index - 1]['value'] = sctframes[1]?.slice(1)?.split(':');
      }
    });
    return sctFrameList;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  updateSptFrames(rowData: any): any {
    let sptFrames = rowData.streamSptFrame;
    const sptFrameList = rowData.framesList[this.parentConfig?.['ip-address-type']]['sptFrameList'];
    let index = 0;
    let isEmix = false;
    let isCustom = false;
    if (sptFrames?.indexOf('EMIX') !== -1 || sptFrames?.indexOf('custom') !== -1) {
      if (sptFrames?.indexOf('EMIX') !== -1) {
        isEmix = true;
        sptFrames = sptFrames?.split('EMIX');
      } else if (sptFrames?.indexOf('custom') !== -1) {
        isCustom = true;
      }
    }
    sptFrameList?.forEach(item => {
      index = index + 1;
      if (
        rowData.streamSptFrame &&
        rowData.streamSptFrame.includes(item['label']) &&
        !isEmix &&
        !isCustom
      ) {
        sptFrameList[index - 1]['enable'] = true;
      } else if (isCustom && item['label'] === 'custom') {
        sptFrameList[index - 1]['enable'] = true;
        sptFrameList[index - 1]['value'] = rowData.streamSptFrame.replace('custom:', '');
      } else if (isEmix && sptFrames?.length > 1 && sptFrameList[index - 1].label === 'EMIX') {
        sptFrameList[index - 1]['enable'] = true;
        sptFrameList[index - 1]['value'] = sptFrames[1]?.slice(1)?.split(':');
      } else {
        sptFrameList[index - 1]['enable'] = false;
      }
    });
    return sptFrameList;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }
  // eslint-disable-next-line
  onDataChange(value?: number, index?: number, name?: string, element?: any): void {
    this.validateAllStreams = this.streamRows.map(item => item['isValidConfig']);

    //Rounding off upto 2 decimal for EIR/CIR/FLR
    if (
      name == Y1564ConfigFieldMapping.LOSS ||
      name == Y1564ConfigFieldMapping.CIR ||
      name == Y1564ConfigFieldMapping.EIR
    ) {
      const rounded = value != null ? Math.round(value * 100) / 100 : null;
      value = rounded;
    }

    //Rounding off upto 3 decimal for FD/FDV
    if (name == Y1564ConfigFieldMapping.FD || name == Y1564ConfigFieldMapping.FDV) {
      const rounded = value != null ? Math.round(value * 1000) / 1000 : null;
      value = rounded;
    }

    if (name) {
      this.allStreamsConfig[index][name] = value;
    }
    if (
      this.vlidateMaxLoad(element) ||
      this.streamRows[0].streamMaxServices <= this.streamRows.length - 1 ||
      this.validateAllStreams?.includes(false)
    ) {
      this.onDataEmit(Y1564ConfigFieldMapping.STREAMS, this.allStreamsConfig, false);
    } else {
      this.onDataEmit(Y1564ConfigFieldMapping.STREAMS, this.allStreamsConfig, true);
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  enforceMaxLength(event: any, maxLength: number) {
    const input = event.target;
    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onBlurDecimalCleanup(element: any, key: string) {
    if (element[key] && element[key].toString().endsWith('.')) {
      element[key] = element[key].toString().slice(0, -1); // Remove trailing '.'
    }
    const raw = element[key];
    const value = parseFloat(raw);
    if (!isNaN(value)) {
      const isThreeDecimal = key === 'streamFD' || key === 'streamFDV';
      const factor = isThreeDecimal ? 1000 : 100;
      const rounded = Math.round(value * factor) / factor;
      element[key] = rounded;
    } else {
      element[key] = '';
    }
  }

  onFDToggleChange(isFDEnabled: boolean, index: number): void {
    if (isFDEnabled) {
      this.allStreamsConfig[index][this.configMapping.FD] = 100;
    } else {
      this.allStreamsConfig[index][this.configMapping.FD] = null;
    }
    this.onDataEmit(Y1564ConfigFieldMapping.STREAMS, this.allStreamsConfig, true);
  }

  isVerifyDSCPSupported(): boolean {
    return this.agentType?.includes('QT') && !this.ipV6Type && this.layer3Test;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  onClickFrameSize(element: any, index: number): void {
    if (this.vlanConfig !== vlanConfigValue.UNTAGGED) {
      element.framesList[this.ipAddressType]['selectedVlans'] =
        this.vlanConfig === vlanConfigValue.Q_IN_Q ? 2 : 1;
    }
    const frameDataObj = {
      rowData: element.framesList[this.ipAddressType],
      sctFrames: this.updateSctFrames(element, 'popup'),
      sptFrames: this.updateSptFrames(element),
      multiSelectFrames: element.framesList['multiSelectFrames'],
      emixFrames: element.framesList['emixFrames'],
      isMultiSelectEnable: element.isMultiSelectEnable,
      configTestEnable: this.isConfigTestEnable,
      performanceTestEnable: this.isPerformanceTestEnable
    };
    const dialogRef = this.dialog.open(FrameSizeSelectorComponent, {
      data: frameDataObj,
      disableClose: true
    });
    dialogRef.beforeClosed().subscribe(_res => {
      if (_res) {
        element.streamSptFrame = _res?.sptFrames;
        element.streamSctFrame = _res?.sctFrames ? _res?.sctFrames : _res?.sptFrames;
        element.isMultiSelectEnable = _res?.isMultiSelectEnable;
        if (
          this.isConfigTestEnable &&
          _res?.isMultiSelectEnable &&
          (_res?.sptFrames == null ||
            _res?.sctFrames?.length === 1 ||
            _res?.sctFrames?.length === 0)
        ) {
          element.streamSctFrame = '512';
        }
        if (
          this.isPerformanceTestEnable &&
          (_res?.sptFrames == '' || _res?.sptFrames == null || _res?.sptFrames?.length === 0)
        ) {
          element.streamSptFrame = '512';
        }
        element['frame-list'] = element.framesList;
        this.onDataChange(
          element.streamSptFrame,
          index,
          Y1564ConfigFieldMapping.SPT_FRAME_SIZE,
          element
        );
        this.onDataChange(
          element.streamSctFrame,
          index,
          Y1564ConfigFieldMapping.SCT_FRAME_SIZE,
          element
        );
        this.onDataChange(element.framesList, index, Y1564ConfigFieldMapping.FRAME_LIST, element);
        this.sctFrameLabelDisplay(element);
        this.sptFrameLabelDisplay(element);
      }
    });
  }

  // eslint-disable-next-line
  enableOrDisableStream(element: any, index: number): void {
    if (element) {
      element.strmInUse = !element.strmInUse;
      this.onDataChange(element.strmInUse, index, Y1564ConfigFieldMapping.STREAM_IN_USE, element);
    }
  }
  // eslint-disable-next-line
  checkRemoveActionValid(element: any): void {
    const enableStreams = this.allStreamsConfig.filter(
      item => item[Y1564ConfigFieldMapping.STREAM_IN_USE]
    );
    if (enableStreams?.length === 1 && element.strmInUse) {
      this.isValidRemove = true;
    } else {
      this.isValidRemove = false;
    }
  }
}
